// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2AdlB","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1Umu7"};